import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import Button from '@nubank/nuds-web/components/Button/Button';

export const CTAButton = styled(Button)`
  &&& {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    margin-bottom: 1rem;
    position: fixed;
    bottom: 0;
    width: calc(100vw - 3rem);
    left: 0;
    ${breakpointsMedia({
    xs: css`
      box-shadow: 1px 4px 16px -6px rgb(0 0 0 / 50%);
    `,
    md: css`
        position: initial;
        width: auto;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 0;
        box-shadow: none;
        height: 2.5rem;
      `,
  })}
    ${({ isHidden }) => (isHidden ? 'display: none;' : '')}
    ${({ background }) => (background ? `background-color: ${background};` : '')}
  }
`;

CTAButton.displayName = 'CTAButton';
